module.exports = __webpack_public_path__ + "static/media/cellphone.202ef466.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/cellphone.svg
// module id = 93
// module chunks = 0